import firebase from "firebase/app"
import 'firebase/auth'
import "firebase/messaging"
import 'firebase/firestore'

firebase.initializeApp({
  // apiKey: "AIzaSyCd1GjVX7hJRgXQrErOZ-KoV6K4a-373do",
  // authDomain: "disaster-kominfo.firebaseapp.com",
  // projectId: "disaster-kominfo",
  // storageBucket: "disaster-kominfo.appspot.com",
  // messagingSenderId: "351950993651",
  // appId: "1:351950993651:web:1089a0bcc523d95d8b1f86"

  apiKey: "AIzaSyCpSBm0ehBiEr4muaISG3Rgm_UNR6Bfd5M",
  authDomain: "klatenkab-b26a2.firebaseapp.com",
  projectId: "klatenkab-b26a2",
  storageBucket: "klatenkab-b26a2.appspot.com",
  messagingSenderId: "403502709904",
  appId: "1:403502709904:web:bc8056a79daf65930f2c15",
  measurementId: "G-89FHTNM0WW"
})

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

navigator.serviceWorker
  .register("firebase-messaging-sw.js", {
    scope: "firebase-cloud-messaging-push-scope",
  })
  .then((registration) => {
    const messaging = firebase.messaging()

    messaging.useServiceWorker(registration)
  })
  .catch((err) => {
    console.log(err)
  })

export const auth = firebase.auth()
export const db = firebase.firestore()

export default firebase